angular.module('components.caOrderArticleDeliveries', [])
    .component('caOrderArticleDeliveries', {
        templateUrl: 'main/order/ordersearch/components/orderarticledeliveries.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            orderArticle: '<'
        },
        controller: controller
    });

// @ngInject
function controller($translate) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.toggleDisplay = toggleDisplay;

    vm.deliveryRows = [];
    vm.displayComponent = false;
    vm.translateDeliveryRowType = translateDeliveryRowType;

    function onInit() {
    }
    function onChanges(changes) {
        if (changes.orderArticle &&
            changes.orderArticle.currentValue) {
            vm.deliveryRows = [];
            _.forEach(vm.orderArticle.orderRows, function(orderRow) {
                _.forEach(orderRow.deliveryRows, function(deliveryRow) {
                    if (deliveryRow.stockTransaction) { //} && deliveryRow.deliveryRowType === "deliveryIn") {
                        vm.deliveryRows.push(deliveryRow);
                        deliveryRow.articleVariant = orderRow.articleVariant;
                    }

                });
            });
            vm.deliveryRows = _.orderBy(vm.deliveryRows, function(deliveryRow) {
                var orderBy = deliveryRow.articleVariant.variantDetail1.variantDetailName + '-' + deliveryRow.articleVariant.variantDetail2.sortOrder.toString();

                if (deliveryRow.stockTransaction) {
                    orderBy = deliveryRow.stockTransaction.accountingDate.split('T')[0] + '-' + orderBy;
                }

                return orderBy;
            });
        }
    }
    function onDestroy() {

    }

    function toggleDisplay() {
        vm.displayComponent = !vm.displayComponent;
    }

    function translateDeliveryRowType(rowType) {
        switch (rowType.toLowerCase()) {
            case 'deliveryout':
                return $translate.instant('order.deliveryTypeOut');
            case 'deliveryin':
                return $translate.instant('order.deliveryTypeIn');
            case 'transit':
                return $translate.instant('order.deliveryTypeTransit');
        }
    }
}
